import { render, staticRenderFns } from "./CheckoutPromoRow.vue?vue&type=template&id=53d2b8a9&"
import script from "./CheckoutPromoRow.vue?vue&type=script&lang=js&"
export * from "./CheckoutPromoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports